@if (currentMeet && currentMeet.meetScores) {
  <!-- index.html -->

  <div [ngClass]="{ 'has-logos': currentMeet.hasLogos }">
    @if (currentMeet.meetScores.length > 2) {
      <ul
        ngbNav
        #nav="ngbNav"
        [(activeId)]="activeTab"
        class="nav-pills nav-pills--secondary nav-pills--page-tabs gap-2 mb-3"
      >
        @for (meetScore of currentMeet.meetScores; track meetScore.id) {
          <li [ngbNavItem]="meetScore.id">
            <button ngbNavLink>
              {{ meetScore.name }}
            </button>
            <ng-template ngbNavContent>
              <h6 (click)="goToScore(meetScore.id)" role="button">
                {{ meetScore.numScoredEvents }}
                @if (meetScore.numScorableEvents) {
                  <span> of {{ meetScore.numScorableEvents }}</span>
                }
                events
              </h6>
              <app-scores-dashlet-table-grid
                [meetScore]="meetScore"
                [meetId]="currentMeet.id"
                [hasLogos]="currentMeet.hasLogos"
              ></app-scores-dashlet-table-grid>
            </ng-template>
          </li>
        }
      </ul>
      <div [ngbNavOutlet]="nav"></div>
    }
    @if (currentMeet.meetScores.length <= 2) {
      <div class="row">
        @for (meetScore of currentMeet.meetScores; track meetScore.id) {
          <div class="col-sm-12 col-md-6 col-lg-12 col-xl-6">
            <h5 (click)="goToScore(meetScore.id)" style="cursor: pointer">{{ meetScore.name }}</h5>
            <h6 (click)="goToScore(meetScore.id)" style="cursor: pointer">
              {{ meetScore.numScoredEvents }}
              @if (meetScore.numScorableEvents) {
                <span> of {{ meetScore.numScorableEvents }}</span>
              }
              events
            </h6>
            <app-scores-dashlet-table-grid
              [meetScore]="meetScore"
              [meetId]="currentMeet.id"
              [hasLogos]="currentMeet.hasLogos"
            ></app-scores-dashlet-table-grid>
          </div>
        }
      </div>
    }
  </div>
}
